<template>
  <div id="deu-cookie-banner" class="deu-cookie-banner">
    <PiveauCookieConsent elementId="deu-cookie-consent-banner" ref="deu-cookie-consent-banner"
      transition-name="slideFromBottom" type="bar" position="bottom" cookie="cookie_consent_drupal" cookie-expires="30D"
      :cookie-config="{ acceptValue: '2', declineValue: '0', postponeValue: '1' }" :no-cookies-until-consent="false"
      :debug="false" :show-postpone-button="false" @status="cookieStatus" @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline" @clicked-postpone="cookieClickedPostpone" @removed-cookie="cookieRemoved">
      <!-- Optional -->
      <template #postponeContent>
        <span class="text-dark">
          &times;
        </span>
      </template>

      <!-- Optional -->
      <template #message>
        <!-- TODO improve and translate me -->
        <div class="text-dark cookie__bar__content__message">{{ $t('message.cookieConsent.text') }}</div>
        <a class="link-more-info text-decoration-none" :href="moreInfoHref" target="_self">
          <u>{{ $t('message.cookieConsent.more') }}</u>
        </a>
      </template>

      <!-- Optional -->
      <template #declineContent>
        <span class="text-white">
          {{ $t('message.cookieConsent.decline') }}
        </span>
      </template>

      <!-- Optional -->
      <template #acceptContent>
        <span class="text-white">
          {{ $t('message.cookieConsent.accept') }}
        </span>
      </template>
    </PiveauCookieConsent>
  </div>
</template>


<script>
import PiveauCookieConsent from './PiveauCookieConsent';

export default {
  components: {
    PiveauCookieConsent
  },
  props: {
    piwikInstance: {
      type: Object,
      default() {
        return this.$piwik;
      }
    },
    moreInfoHref: {
      type: String,
      default() {
        return `/${this?.i18n.global.locale || this?.$route?.query?.locale || 'en'}/legal-notice`
      }
    }
  },
  created() {
    if (!this.piwikInstance) console.error('No Piwik instance specified.');
    if (!this?.i18n.global.locale && !this?.$route?.query?.locale) console.warn('No i18n nor vue-router found. Fallback to "en" locale.')

    window._paq = window._paq || [];
    window.dataLayer = window.dataLayer || [];
    if (this.piwikInstance.type === 'piwikpro') this.initTracker();
  },
  methods: {
    cookieClickedAccept() {
      // Authorize Matomo tracker
      // window._paq.push(['rememberConsentGiven']);
      if (this.piwikInstance.type === 'matomo') this.initTracker();
      this.piwikInstance.consentGiven();
    },
    cookieClickedDecline() {
      if (this.declineJumpToHref) {
        window.open(this.declineJumpToHref, '_blank');
      }
      this.piwikInstance.consentDeclined();
    },
    cookieClickedPostpone() {
      this.piwikInstance.consentNoDecision();
    },
    cookieStatus(status) {
      if (this.piwikInstance.type === 'matomo') {
        if (status === 'accept') {
          this.initTracker();
          this.piwikInstance.consentGiven();
        } else if (status === 'decline') {
          this.piwikInstance.consentDeclined();
        } else if (status === 'postponed') {
          this.piwikInstance.consentNoDecision();
        }
      }
    },
    cookieRemoved() {
      this.piwikInstance.consentDeclined();
    },
    initTracker() {
      this.piwikInstance.init();
    },
  },
}
</script>

<style lang="scss" scoped>
$bg-color: #ebebeb;
$light: #f8f9fa;
$deu-blue: #0E47CB;

.text-dark {
  color: #343a40 !important
}

.text-white {
  color: white !important;
}
// if you see this, erase me (testClass)
.testClass{
display: none;
}
.link-more-info {
  text-decoration: none;
  color: $deu-blue;
  line-height: 1.875rem;
  grid-column: 2/-1;
  place-self: flex-start;
}

.deu-cookie-banner {
  z-index: 9999;
  position: sticky;
  // top: 0;
}

.deu-cookie-banner::v-deep {
  .cookie {
    color: white;
  }

  .cookie__bar {
    position: fixed;
    padding: 1.5rem 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: $bg-color;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 30px;

    &__content {
      display: grid;
      grid-template-columns: 5% auto;
      -webkit-column-gap: 1.5rem;
      -moz-column-gap: 1.5rem;
      column-gap: 1.5rem;
      margin-top: 0;

      &__message {
        line-height: 1.875;
      }

      &:before {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23004593' width='24px' height='24px'%3E%3Cpath d='M15.086 18.175H8.913v-1.508h1.508v-4.665H8.913v-1.507h4.665v6.172h1.576v1.508h-.068zM10.42 7c0-.617.548-1.166 1.165-1.166h.754c.617 0 1.165.549 1.165 1.166v.753c0 .617-.548 1.165-1.165 1.165h-.754c-.617 0-1.165-.548-1.165-1.165V7zM11.998.005A11.97 11.97 0 000 12.002 11.97 11.97 0 0011.998 24a11.97 11.97 0 0011.997-11.998c0-6.647-5.414-11.997-11.998-11.997z'%3E%3C/path%3E%3C/svg%3E");
        height: 1.5rem;
        width: 1.875rem;
      }
    }

    &__wrap {
      row-gap: 1.5rem;
      flex-direction: column;
      position: relative;
      max-width: 100%;
      margin: 0 1rem;
    }
  }

  .cookie__bar__buttons {
    display: flex;
    flex-wrap: wrap;
    place-content: flex-end;
    gap: .5rem;
    margin: 0;
  }



  .cookie__bar__buttons__button {
    background: $deu-blue;
    font-size: 16px;
    line-height: 1.875rem;
    font-weight: 600;
    padding: .625rem 1rem;
    border-radius: 4;

    &--accept {
      // background: $light;
      color: black;
      font-weight: 700;
      margin: 0;
 
    }

    &:hover {
      // background: darken($light, 8%);
      background-color: #002f67;
    }

    &:focus {
      outline: 3px solid #ffd617;
      outline-offset: -3px;
    }

    // &--decline {
    //   font-size: 1em;
    //   background: transparent;
    //   padding: 1px 6px;
    //   margin-right: 5px;
    //   border: 0;
    //   font-weight: 400;

    //   &:hover {
    //     background: transparent;
    //   }
    // }
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 480px) {
  #deu-cookie-banner .cookie__bar__wrap {
    width: 28rem !important;
  }
}

@media screen and (min-width: 768px) {
  #deu-cookie-banner .cookie__bar__wrap {
    -webkit-box-orient: inherit;
    -webkit-box-direction: inherit;
    -ms-flex-direction: inherit;
    flex-direction: inherit !important;
    width: 46rem !important;
    max-width: 100% !important;
  }
}

@media screen and (min-width: 1140px) {
  #deu-cookie-banner .cookie__bar__wrap {
    width: 60.25rem !important;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}

@media screen and (min-width: 996px) {
  #deu-cookie-banner .cookie__bar__wrap {
    width: 69.25rem !important;
  }
}

@media screen and (min-width: 601px) {
  #deu-cookie-banner .cookie__bar__wrap {
    width: 95%;
    align-items: flex-start;
  }
}
</style>
